import { Controller } from "@hotwired/stimulus"
import { SUBDOCUMENT_TYPES } from "../data/subdocument_types"

export default class extends Controller {
  static targets = ["input", "tipoSelect", "dropzoneArea", "subtipoCount", "subtipoSelectedList", "subtipoHidden", "subtipoToggle"]
  static requiredTargets = ["input", "tipoSelect", "subtipoCount", "subtipoSelectedList", "subtipoHidden", "dropzoneArea", "subtipoToggle"]

  connect() {
    this.dropzoneController = this.application.getControllerForElementAndIdentifier(
      this.dropzoneAreaTarget,
      'dropzone'
    )

    this.setSubtipoEnabled(Boolean(this.tipoSelectTarget.value))
    requestAnimationFrame(() => this.checkInputs())
  }

  updateSubtipo() {
    const selectedType = this.tipoSelectTarget.value
    const subtipoCheckboxesDiv = this.subtipoCheckboxesContainer()

    if (!subtipoCheckboxesDiv) return

    subtipoCheckboxesDiv.innerHTML = ''

    this.subtipoHiddenTarget.value = ''
    this.subtipoCountTarget.textContent = '0'
    this.subtipoSelectedListTarget.textContent = 'Ninguno'
    this.resetSelectAll()
    this.setSubtipoEnabled(Boolean(selectedType))

    if (selectedType && SUBDOCUMENT_TYPES[selectedType]) {
      const options = SUBDOCUMENT_TYPES[selectedType]
      options.forEach((option, i) => {
        const id = `subtipo_${selectedType}_${i}`
        const wrapper = document.createElement('div')
        wrapper.className = 'form-check'

        const checkbox = document.createElement('input')
        checkbox.type = 'checkbox'
        checkbox.className = 'form-check-input'
        checkbox.value = option.value
        checkbox.id = id
        checkbox.dataset.label = option.label
        checkbox.setAttribute('data-select-all-target', 'child')
        checkbox.addEventListener('change', () => this.updateSubtipoSelected())

        const label = document.createElement('label')
        label.className = 'form-check-label ml-2'
        label.htmlFor = id
        label.textContent = option.label

        wrapper.appendChild(checkbox)
        wrapper.appendChild(label)
        subtipoCheckboxesDiv.appendChild(wrapper)
      })
    }

    this.checkInputs()
  }

  updateSubtipoSelected() {
    const subtipoCheckboxesDiv = this.subtipoCheckboxesContainer()

    if (!subtipoCheckboxesDiv) return

    const checked = Array.from(subtipoCheckboxesDiv.querySelectorAll('input[type="checkbox"]:checked'))
    const values = checked.map((checkbox) => checkbox.value)
    const labels = checked.map((checkbox) => checkbox.dataset.label || checkbox.value)

    this.subtipoHiddenTarget.value = values.join(',')
    this.subtipoCountTarget.textContent = String(values.length)
    this.subtipoSelectedListTarget.textContent = labels.length > 0 ? labels.join(', ') : 'Ninguno'
    this.syncSelectAllState(subtipoCheckboxesDiv)
    this.checkInputs()
  }

  checkInputs() {
    if (!this.dropzoneController) {
      this.dropzoneController = this.application.getControllerForElementAndIdentifier(
        this.dropzoneAreaTarget,
        'dropzone'
      )
      if (!this.dropzoneController) return
    }

    const fechaField = this.element.querySelector('#archivo_fecha')
    const horaField = this.element.querySelector('#archivo_hora')
    const message = this.dropzoneAreaTarget.querySelector('.dropzone-msg-desc')
    const fecha = fechaField ? fechaField.value : ''
    const hora = horaField ? horaField.value : ''
    const tipo = this.tipoSelectTarget.value
    const subtipo = this.subtipoHiddenTarget.value
    const allFilled = Boolean(fecha && hora && tipo && subtipo)

    if (allFilled) {
      this.dropzoneController.enable()
      if (message) message.textContent = 'Arrastre y suelte aquí los archivos que desea subir.'
    } else {
      this.dropzoneController.disable()
      if (message) message.textContent = 'Debe completar fecha, hora, tipo y subtipo de documento para habilitar la carga.'
    }
  }

  disconnect() {
    this.dropzoneController = null
  }

  subtipoCheckboxesContainer() {
    return this.element.querySelector('#subtipo-checkboxes')
  }

  selectAllCheckbox() {
    return this.element.querySelector('#select_all_subtipos')
  }

  resetSelectAll() {
    const selectAll = this.selectAllCheckbox()
    if (!selectAll) return

    selectAll.checked = false
    selectAll.disabled = !this.tipoSelectTarget.value
  }

  syncSelectAllState(container) {
    const selectAll = this.selectAllCheckbox()
    if (!selectAll) return

    const checkboxes = Array.from(container.querySelectorAll('input[type="checkbox"]'))
    const checkedCount = checkboxes.filter((checkbox) => checkbox.checked).length

    selectAll.disabled = checkboxes.length === 0
    selectAll.checked = checkboxes.length > 0 && checkedCount === checkboxes.length
  }

  setSubtipoEnabled(enabled) {
    this.subtipoToggleTarget.disabled = !enabled
    this.subtipoToggleTarget.classList.toggle('disabled', !enabled)

    const selectAll = this.selectAllCheckbox()
    if (selectAll) selectAll.disabled = !enabled
  }
}
